import { g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import styled, { css } from 'styled-components'

export const GraphContainer = styled.div`
  border-radius: ${g(1)};
  border: 1px solid ${({ theme }) => theme.colors.neutral3};
  padding: ${g(4)};
`
export const Title = styled.div`
  ${typo.headline16};
  margin-bottom: ${g(3)};
`
export const Graph = styled.div`
  display: grid;
  grid-template-columns: auto repeat(${({ $bars }) => $bars}, 1fr) auto;
  grid-template-rows: auto repeat(${({ $steps }) => $steps}, 1fr) auto auto;
  align-items: center;
`
const Caption = styled.div`
  ${typo.caption12};
  color: ${({ theme }) => theme.colors.neutral2};
`
const ColumnTitle = styled.div`
  ${typo.link12};
  color: ${({ theme }) => theme.colors.neutral2};
`
export const PaymentTitle = styled(ColumnTitle)`
  grid-column: 1 / span 2;
`
export const TotalTitle = styled(ColumnTitle)`
  grid-column: -3 / span 2;
  text-align: right;
`
export const PaymentValue = styled(Caption)`
  grid-column-start: 1;
  text-align: right;
  grid-row-start: ${({ $index }) => $index + 2};
  height: ${g(5)};
  line-height: ${g(5)};
  margin-right: ${g(2)};
`
export const Line = styled.div`
  height: 1px;
  background-color: ${({ theme, $isLast }) => ($isLast ? theme.colors.neutral3 : theme.colors.neutral4)};
  grid-column: 2 / -2;
  grid-row-start: ${({ $index }) => $index + 2};
`
export const TotalValue = styled(Caption)`
  grid-column-start: -2;
  grid-row-start: ${({ $index }) => $index + 2};
  height: ${g(5)};
  line-height: ${g(5)};
  margin-left: ${g(2)};
`
export const BarContainer = styled.div`
  grid-column-start: ${({ $index }) => $index + 2};
  grid-row: 3 / -3;
  height: 100%;
  position: relative;
  display: flex;
  justify-content: center;
  transform: translateY(${g(-2.5)});
`
export const Bar = styled.div`
  height: 100%;
  width: ${g(2)};
  position: relative;
  cursor: help;
  transition: background-color 150ms ease-in-out;

  &:hover {
    background-color: ${({ theme }) => theme.colors.neutral4};
  }
`
const BarValue = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: -1px;
  border-radius: ${g(1)} ${g(1)} 0 0;

  &::before {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
    border-radius: inherit;
    content: '';

    ${Bar}:hover & {
      left: -1px;
      right: -1px;
      top: -1px;
    }
  }
`
export const BarPrincipal = styled(BarValue)`
  background-color: ${({ theme }) => theme.colors.primary2};
  z-index: 2;

  &::before {
    background-color: ${({ theme }) => theme.colors.primary2};
  }
`
export const BarInterests = styled(BarValue)`
  background-color: ${({ theme }) => theme.colors.primary3};
  z-index: 1;

  &::before {
    background-color: ${({ theme }) => theme.colors.primary3};
  }
`
export const DotTotal = styled.div`
  position: absolute;
  left: 50%;
  width: ${g(1)};
  height: ${g(1)};
  border-radius: ${g(1)};
  transform: translate(-50%, 50%) scale(1);
  transition: transform 150ms ease-in-out;
  background-color: ${({ theme }) => theme.colors.accent1};
  z-index: 3;

  ${Bar}:hover & {
    transform: translate(-50%, 50%) scale(1.2);
  }
`

export const BarDuration = styled(Caption)`
  justify-self: center;
  grid-column-start: ${({ $index }) => $index + 2};
  grid-row-start: -3;

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: ${({ theme }) => theme.colors.neutral1};
      text-decoration: underline;
    `}
`
export const Legends = styled.div`
  ${typo.caption12};
  grid-column: 1 / -1;
  grid-row-start: -2;
  display: flex;
  justify-content: center;
  margin-top: ${g(3)};
`
export const Legend = styled.div`
  position: relative;
  padding-left: ${g(2)};

  &::before {
    position: absolute;
    content: '';
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: ${g(1)};
    height: ${g(1)};
    border-radius: ${g(1)};
    background-color: ${({ theme, $dotColor }) => theme.colors[$dotColor]};
  }

  & + & {
    margin-left: ${g(3)};
  }
`
export const Tooltip = styled.div`
  text-align: center;
`
export const TooltipInterests = styled.div`
  ${typo.caption12};
`
